/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName } from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';
import {
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSONTyped,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON,
} from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';
import type { ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress } from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress';
import {
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressFromJSON,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressFromJSONTyped,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressToJSON,
} from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress';
import type { ExecRiskUSAddress } from './ExecRiskUSAddress';
import {
    ExecRiskUSAddressFromJSON,
    ExecRiskUSAddressFromJSONTyped,
    ExecRiskUSAddressToJSON,
} from './ExecRiskUSAddress';

/**
 * 
 * @export
 * @interface ExecRiskUnrelatedOrgTxblPartnership
 */
export interface ExecRiskUnrelatedOrgTxblPartnership {
    /**
     * 
     * @type {ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName}
     * @memberof ExecRiskUnrelatedOrgTxblPartnership
     */
    BusinessName?: ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName;
    /**
     * 
     * @type {ExecRiskUSAddress}
     * @memberof ExecRiskUnrelatedOrgTxblPartnership
     */
    USAddress?: ExecRiskUSAddress;
    /**
     * 
     * @type {ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress}
     * @memberof ExecRiskUnrelatedOrgTxblPartnership
     */
    ForeignAddress?: ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskUnrelatedOrgTxblPartnership
     */
    EIN?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskUnrelatedOrgTxblPartnership
     */
    PrimaryActivitiesTxt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskUnrelatedOrgTxblPartnership
     */
    LegalDomicileStateCd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskUnrelatedOrgTxblPartnership
     */
    LegalDomicileForeignCountryCd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskUnrelatedOrgTxblPartnership
     */
    PredominateIncomeDesc?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskUnrelatedOrgTxblPartnership
     */
    AllPartnersC3SInd?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskUnrelatedOrgTxblPartnership
     */
    ShareOfTotalIncomeAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskUnrelatedOrgTxblPartnership
     */
    ShareOfEOYAssetsAmt?: number;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskUnrelatedOrgTxblPartnership
     */
    DisproportionateAllocationsInd?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskUnrelatedOrgTxblPartnership
     */
    UBICodeVAmt?: number;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskUnrelatedOrgTxblPartnership
     */
    GeneralOrManagingPartnerInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskUnrelatedOrgTxblPartnership
     */
    OwnershipPct?: string;
}

/**
 * Check if a given object implements the ExecRiskUnrelatedOrgTxblPartnership interface.
 */
export function instanceOfExecRiskUnrelatedOrgTxblPartnership(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskUnrelatedOrgTxblPartnershipFromJSON(json: any): ExecRiskUnrelatedOrgTxblPartnership {
    return ExecRiskUnrelatedOrgTxblPartnershipFromJSONTyped(json, false);
}

export function ExecRiskUnrelatedOrgTxblPartnershipFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskUnrelatedOrgTxblPartnership {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'BusinessName': !exists(json, 'BusinessName') ? undefined : ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON(json['BusinessName']),
        'USAddress': !exists(json, 'USAddress') ? undefined : ExecRiskUSAddressFromJSON(json['USAddress']),
        'ForeignAddress': !exists(json, 'ForeignAddress') ? undefined : ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressFromJSON(json['ForeignAddress']),
        'EIN': !exists(json, 'EIN') ? undefined : json['EIN'],
        'PrimaryActivitiesTxt': !exists(json, 'PrimaryActivitiesTxt') ? undefined : json['PrimaryActivitiesTxt'],
        'LegalDomicileStateCd': !exists(json, 'LegalDomicileStateCd') ? undefined : json['LegalDomicileStateCd'],
        'LegalDomicileForeignCountryCd': !exists(json, 'LegalDomicileForeignCountryCd') ? undefined : json['LegalDomicileForeignCountryCd'],
        'PredominateIncomeDesc': !exists(json, 'PredominateIncomeDesc') ? undefined : json['PredominateIncomeDesc'],
        'AllPartnersC3SInd': !exists(json, 'AllPartnersC3SInd') ? undefined : json['AllPartnersC3SInd'],
        'ShareOfTotalIncomeAmt': !exists(json, 'ShareOfTotalIncomeAmt') ? undefined : json['ShareOfTotalIncomeAmt'],
        'ShareOfEOYAssetsAmt': !exists(json, 'ShareOfEOYAssetsAmt') ? undefined : json['ShareOfEOYAssetsAmt'],
        'DisproportionateAllocationsInd': !exists(json, 'DisproportionateAllocationsInd') ? undefined : json['DisproportionateAllocationsInd'],
        'UBICodeVAmt': !exists(json, 'UBICodeVAmt') ? undefined : json['UBICodeVAmt'],
        'GeneralOrManagingPartnerInd': !exists(json, 'GeneralOrManagingPartnerInd') ? undefined : json['GeneralOrManagingPartnerInd'],
        'OwnershipPct': !exists(json, 'OwnershipPct') ? undefined : json['OwnershipPct'],
    };
}

export function ExecRiskUnrelatedOrgTxblPartnershipToJSON(value?: ExecRiskUnrelatedOrgTxblPartnership | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'BusinessName': ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON(value.BusinessName),
        'USAddress': ExecRiskUSAddressToJSON(value.USAddress),
        'ForeignAddress': ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressToJSON(value.ForeignAddress),
        'EIN': value.EIN,
        'PrimaryActivitiesTxt': value.PrimaryActivitiesTxt,
        'LegalDomicileStateCd': value.LegalDomicileStateCd,
        'LegalDomicileForeignCountryCd': value.LegalDomicileForeignCountryCd,
        'PredominateIncomeDesc': value.PredominateIncomeDesc,
        'AllPartnersC3SInd': value.AllPartnersC3SInd,
        'ShareOfTotalIncomeAmt': value.ShareOfTotalIncomeAmt,
        'ShareOfEOYAssetsAmt': value.ShareOfEOYAssetsAmt,
        'DisproportionateAllocationsInd': value.DisproportionateAllocationsInd,
        'UBICodeVAmt': value.UBICodeVAmt,
        'GeneralOrManagingPartnerInd': value.GeneralOrManagingPartnerInd,
        'OwnershipPct': value.OwnershipPct,
    };
}

